import React from 'react';
import { Card } from 'antd';

interface Props {
  title?: string;
  children: React.ReactNode;
  style?: React.CSSProperties;
}

export const SectionCard: React.FC<Props> = ({ title, children, style }) => (
  <Card
    title={title}
    size="small"
    style={{
      margin: 'var(--bl-space-2) var(--bl-space-4)',
      borderRadius: 'var(--bl-radius-card)' as string,
      boxShadow: 'var(--bl-shadow-card)',
      border: '1px solid var(--bl-divider)',
      ...style,
    }}
    styles={{ body: { padding: 'var(--bl-space-3) var(--bl-space-4)' } }}
  >
    {children}
  </Card>
);
